import { Suspense, lazy } from "react";

import { Layout } from "../../features/layout";

const Content = lazy(() => import("./ComplianceContent"));

export function CompliancePage() {
  return (
    <Layout>
      <Suspense fallback={null}>
        <Content />
      </Suspense>
    </Layout>
  );
}
